import _DatabaseModel from "./_DatabaseModel";

const ROLES_TAB_PERMISSIONS = 132;
const ROLES_TAB_USERS = 133;

class Role extends _DatabaseModel {
  static model = "role";
  static showSize = 8;
  static editDialogComponent = "roles-edit-dialog";
  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];

  static show = {
    buttons: ["edit"],
    reloadingModels: ["role_user"],
  };

  static filter = {
    parts: {
      fields: ["name", "description", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "permission.permissions",
      permission: ROLES_TAB_PERMISSIONS,
      component: "PermissionsTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "person.persons",
      permission: ROLES_TAB_USERS,
      component: "UsersTab",
      disabled: this.defaultDisabledTab(),
    },
  ];
}

export default Role;
